import { render } from "./DownloadBrochure.vue?vue&type=template&id=62611fec"
import script from "./DownloadBrochure.vue?vue&type=script&lang=js"
export * from "./DownloadBrochure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__